document.addEventListener("DOMContentLoaded", () => {
  const swatchLists = document.querySelectorAll(".merox__gridSwatches");
  function handleSwatchClick(event) {
    const variantId = this.getAttribute("data-variant-id");
    const title = this.getAttribute("data-title");
    const url = this.getAttribute("data-href");
    const productItem = event.target.closest(".merox_gitem");
    const colorOption = productItem.querySelector(".lipstickSelectedOption");
    const prodTitle = productItem.querySelector(".mero_coll.title");
    productItem.querySelector(".m-product-image").setAttribute('href', url);
    productItem.querySelector(".m-product-details a").setAttribute('href', url);
    prodTitle.innerText = title;
    colorOption.value = variantId;
    const variantImage = this.getAttribute("data-variant-image");
    const imageSelector = productItem.querySelector(".m-product-img-tag");
    imageSelector.src = variantImage;
    const clickedSwatch = event.target.closest(".swatch");
    if (clickedSwatch) {
      const swatches = clickedSwatch.parentElement.querySelectorAll(".swatch");
      swatches.forEach((swatch) => swatch.classList.remove("active"));
      clickedSwatch.classList.add("active");
    }
  }
  swatchLists.forEach((swatchList) => {
    const swatches = swatchList.querySelectorAll(".swatch");
    swatches.forEach((swatch) =>
      swatch.addEventListener("click", handleSwatchClick)
    );
  });

  var buttons = document.querySelectorAll(".plusIcon");
  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      const productItem = event.target.closest(".merox_gitem");
      const nextGridSwatches = productItem.querySelector(".nextGridSwatches");

      if (nextGridSwatches.style.display === "none") {
        nextGridSwatches.style.display = "block";
      } else {
        nextGridSwatches.style.display = "none";
      }
      const url = this.getAttribute("data-product-url");
      console.log(url);
      window.location.href = url;
    });
  });
});
